import { AxiosResponse } from "axios";
import axiosInstance from "../apis";
import { BASE_URL_V2 } from "../constants";

export const getAppVersions = (
  search?: string
): Promise<AxiosResponse<{ data: { appVersions: string[] } }>> => {
  return new Promise((resolve, reject) => {
    const params: any = {
      limit: 100,
    };

    if (search) {
      params.value = search;
    }

    axiosInstance
      .get("admin/appversion", { params, baseURL: BASE_URL_V2 })
      .then((res) => resolve(res))
      .catch((e) => reject(e));
  });
};
